<template>
    <div style="height: calc(100vh - 45px); overflow: scroll;">
        <div style="position: fixed;bottom:0;left:0;width: 100%;">
         <van-button
          style="width: 100%;"
          type="primary"
          @click="add"
          >新增教师</van-button
        >
        </div>
      <!-- <van-sticky :offset-top="'90vh'">
          <van-button
          style="width: 100%;"
          type="primary"
          @click="add"
          >新增教师</van-button
        >
      </van-sticky> -->

        <!-- <div style="background-color: #fff;"> -->
          <!-- <h4>请选择测试班级</h4> -->
        <!-- <van-field readonly style="margin:5px 0" v-model="searchObj.className"  label="选择班级" placeholder="请选择班级" :rules="[{ required: true }]" @click="classShowPicker = true;" /> -->
        <!-- </div> -->

        <!-- <van-nav-bar>
          <template #right>
            <van-icon
              name="search"
              color="black"
              size="24"
              @click="searchShow = true"
            />
          </template>
        </van-nav-bar>
        <van-popup v-model="searchShow" position="top">
          <van-search v-model="searchStr" placeholder="请输入搜索关键词" />
        </van-popup> -->
      <!-- <van-popup v-model="classShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-picker :columns="classList"  show-toolbar @cancel="classShowPicker = false"
        @confirm="onConfirmClass" />
    </van-popup> -->


    <van-popup v-model="addTeacherShowPicker" round position="bottom" :style="{ height: '55%' }">
        
        <!-- sex ,teacherName,phoneNumber, schoolCode -->

<van-cell-group inset>
  <van-field v-model="submitData.teacherName" label="姓名" placeholder="请输入姓名" />
  <van-field v-model="submitData.phoneNumber" label="手机号" placeholder="请输入手机号" />
  <van-field v-model="submitData.sex" label="性别" placeholder="请输入性别" >
     <template #input>
       <van-radio-group v-model="submitData.sex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
       </van-radio-group>
    </template>
  </van-field>

    <div style="margin-top: 50px;">
         <van-button
          style="width: 50%;"
          type="warning"
          @click="addTeacherShowPicker = false"
          >取消</van-button
        >
         <van-button
          style="width: 50%;"
          type="primary"
          @click="confirm"
          >确定</van-button
        >
    </div>
</van-cell-group>


    </van-popup>

<div v-for="(item,i) in dataList" :key="i">
<van-cell :title="item.teacherName" :label="item.phoneNumber" is-link   />
</div>



   <!-- <el-table
    :data="dataList"
    size='mini'
    border
    stripe
    style="width: 100%">
    
    <el-table-column
      prop="studentName"
      label="姓名"
      align="center"
      width="80">
    </el-table-column>
    <el-table-column
      prop="snCode"
      align="center"
      label="学号"
      >
    </el-table-column>
       <el-table-column
      prop="sex"
      align="center"
      label="性别"
      width="60">
    </el-table-column>
     <el-table-column
      prop="address"
      align="center"
      label="查看">
      <template slot-scope="scope">
         <van-button
          type="primary"
          size="mini"
          @click="goInfo(scope.row)"
          >查看</van-button
        >
       </template>
    </el-table-column>
  </el-table> -->

    </div>
  </template>
  
  <script>
import { getClassInfoList,selectTeacherList,installTeacher} from "@/api/teacher/addTeacher.js";
 import { setSession ,getSession} from "@/utils/cookie";
import { Dialog } from 'vant';

  export default {
    data() {
      return {
        submitData:{
            sex:'男'
        },
        dropdownValue:'',
        dropdownOption:[ 
        { text: '全部', value: '' },
        { text: '引体向上', value: 'PullUp' },
        { text: '立定跳远', value: 'Jump' },
        { text: '坐位体前屈', value: 'SitAndReach' },
        { text: '仰卧起坐', value: 'SitUp' },
        { text: '体重/身高', value: 'HeightWeight' },
        { text: '肺活量', value: 'VitalCapacity' },
        { text: '双杠臂屈伸', value: 'TricepsDip' },
        { text: '纵跳摸高', value: 'TricepsDip' },
        ],
        searchShow: false,
        searchStr: "",

        tabList: [
          { name: "待审核", value: "0" },
          { name: "通过", value: "2" },
          { name: "驳回", value: "3" },
        ],
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        wfType: "0",
        reqType:null,
        classList:[],
        classShowPicker:false,
        searchObj:{},
        teacherTitleInfo:{},
        addTeacherShowPicker:false
      };
    },
    components: {
    },
    filters: {
      stateFil(val) {
        const obj = {
          "1": "待审核",
          "2": "审核通过",
          "3": "审核驳回",
          "4": "作废",
        };
        if (val) {
          return obj[val];
        } else {
          return "待提交";
        }
      },
      appealTypeFil(val) {
        const obj = {
          "1": "未识别人脸",
          "2": "未经过点位",
          "3": "未检录",
        };
        if (val) {
          return obj[val];
        } else {
          return "";
        }
      },
    },
    created() {
   this.teacherTitleInfo =  JSON.parse(sessionStorage.getItem('teacherTitleInfo'))

      this.loading = true;
      this.finished = false;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.setupList = [];
       this.getList()

   
    },
    methods: {
        confirm(){
 Dialog.confirm({
        title: '提示',
        message: '是否确定新增教师账号？！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.installTeacher()
        })
        .catch(() => {});
        },
        installTeacher(){

            let data = {
                sex:this.submitData.sex,
                teacherName:this.submitData.teacherName,
                phoneNumber:this.submitData.phoneNumber,
                schoolCode:this.teacherTitleInfo.schoolCode
            }
            installTeacher(data).then(res=>{
                this.addTeacherShowPicker = false
                this.submitData={
                            sex:'男'
                }
            this.$notify({ type: "success", message: '操作成功！' });

            })
        },
        add(){
            this.addTeacherShowPicker = true
        },
      goInfo(row){
        setSession('teacherReporting/classReporting',JSON.stringify(this.searchObj))
   this.$router.push({path:'teacherReporting/reportingList',query:{snCode:row.snCode,schoolCode:row.schoolCode}})

      },
        onConfirmClass(val){
            console.log(val)
            this.searchObj.classCode = val.value
            this.searchObj.className = val.text
            this.classShowPicker =false
        },
        init(){
            getClassInfoList({}).then(res=>{
          
              this.classList = res.data.data.map((item) => {
                return { text:item.gradeName + '-' +item.className, value: item.classCode };
              });
             // this.classList = res.data.data
                console.log(res)
            })
        },
        getList(){
            selectTeacherList({
              classCode:this.searchObj.classCode ,
              studentName:this.searchObj.studentName ,
              schoolCode:this.teacherTitleInfo.schoolCode
            }).then(res=>{
                console.log(res);
                
                this.dataList = res.data.body
            })
        },
      //切换tab
      onStatus(e) {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.wfType = e;
        this.onLoad();
      },
      dropdownChange() {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.onLoad();
      },
      //查列表
      onLoad() {

 this.reqType.post(`/runGroupAppeal/listRunGroupAppeal?pageNumber=${this.pageIndex}&rowNumber=${this.pageSize}`,{
     appealStatus:this.wfType,
     detectionType:this.dropdownValue,
 }).then(res=>{
     console.log(res);
     if (res.header.code==0) {
         if (res.body.list.length > 0) {
              res.body.list.forEach(el=>{
            switch (el.detectionType) {
            case 'HeightWeight':el.detectionTypeName = '体重/身高',el.preFinishSecondsName = el.preFinishSeconds + 'BMI';break
            case 'TZ':el.detectionTypeName = '体重',el.preFinishSecondsName = el.preFinishSeconds + 'KG';break
            case 'VitalCapacity':el.detectionTypeName = '肺活量',el.preFinishSecondsName = el.preFinishSeconds + 'ML';break
            case 'Jump':el.detectionTypeName = '立定跳远',el.preFinishSecondsName = el.preFinishSeconds + 'CM';break
            case 'PullUp':el.detectionTypeName = '引体向上',el.preFinishSecondsName = el.preFinishSeconds + '个';break
            case 'SitUp':el.detectionTypeName = '仰卧起坐',el.preFinishSecondsName = el.preFinishSeconds + '个';break
            case 'SitAndReach':el.detectionTypeName = '坐位体前屈',el.preFinishSecondsName = el.preFinishSeconds + 'CM';break
            case 'TricepsDip':el.detectionTypeName = '双杠臂屈伸';break
            case 'LengthwaysJump':el.detectionTypeName = '纵跳摸高';break
            case 'RUN50':el.detectionTypeName = '50米';break
            case 'RUN800':el.detectionTypeName = '800米';break
            case '1000米':el.detectionTypeName = 'RUN1000';break
            default:el.detectionTypeName = '未知'
              break;
          }
          })
            this.pageIndex++;
            this.dataList = this.dataList.concat(res.body.list);
            this.loading = false;
          } else {
            this.finished = true;
          }
     }

       })
   
      },
      //查看详情
      openInfo(dataId) {
         this.$router.push({
           name: "indoorAuditInfo",
           query: { dataId: dataId ,wfType:this.wfType,runType:this.$route.query.runType},
         });
      },
    },
  };
  </script>
  
  <style  lang="less" scoped>
    .boxlist{
      padding: 6px;
      margin: 6px;
      border: 1px solid #ccc;
      border-radius: 10px;
      background-color: #fff;
      font-size: 14px;
      color: #323233;
      line-height: 24px;
      
      box-shadow: inset calc(-1px * var(--dir-factor)) 0 0 rgba(0, 0, 0, 0.25);
    }
    ::v-deep .van-cell__label{
      color: #1a1a1a;
    }
  </style>